export class Filtros {
    public Atributo:string;
    public Valor:string;

    constructor(isAtributo:string, isValor:string){
        this.Atributo = isAtributo;
        this.Valor = isValor;
    }
}
